import { createSlice } from "@reduxjs/toolkit";
import { fetchTranslations, patchTranslationsThunk } from "../thunk/translationsThunk";

type TranslationState = {
  data: Record<string, Record<string, Record<string, Record<string, string>>>>; 
  loading: boolean;
};

const initialState: TranslationState = {
  data: {},
  loading: false,
};

const translationsSlice = createSlice({
  name: "translations",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTranslations.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTranslations.fulfilled, (state, action) => {
        const { entityType, entityId, property, data } = action.payload;
        if (!state.data[entityType]) state.data[entityType] = {};
        if (!state.data[entityType][entityId]) state.data[entityType][entityId] = {};
        state.data[entityType][entityId][property] = data;
        state.loading = false;
      })
      .addCase(fetchTranslations.rejected, (state) => {
        state.loading = false;
      })
      .addCase(patchTranslationsThunk.fulfilled, (state, action) => {
        const { entityType, entityId, property, translations } = action.payload;
        if (!state.data[entityType]) state.data[entityType] = {};
        if (!state.data[entityType][entityId]) state.data[entityType][entityId] = {};
        state.data[entityType][entityId][property] = translations;
      });
  },
});

export default translationsSlice.reducer;
